import { NotificationSound } from '../typings/notificationPayload'

export enum DesktopPushNotificationType {
  CHAT = 'CHAT',
  PARTICIPANTS_ADDED = 'PARTICIPANTS_ADDED',
  CONVERSATION_CLASSIFIED = 'CONVERSATION_CLASSIFIED',
  VIDEO_VIEW_PUSH = 'video_view_push'
}

export interface ABMData {
  accountId: string
  companyName: string
  endUserId: string
  page: string
}

export interface NotificationBase {
  tag?: string
  title: string
  body: string
  soundOn: boolean
  sound?: NotificationSound
  type?: DesktopPushNotificationType
}

export interface ConversationNotification extends NotificationBase {
  conversationId: number | ''
  messageId?: number
  type: DesktopPushNotificationType
}

export interface ABMNotification extends NotificationBase {
  ABMData: ABMData
}

export interface ExternalNotification extends NotificationBase {
  onClickUrl: string
  type: DesktopPushNotificationType
}
